import { componentDidMount } from '../../components/Lifecycles'
import { compose } from 'ramda'
import { connect } from 'react-redux'
import { injectBrightcoveVideoSchema } from '../../store/modules/header'

const mapDispatchToProps = dispatch => ({
  injectBrightcoveVideoSchema: compose(dispatch, injectBrightcoveVideoSchema),
})

// didMount :: Props -> Action
const didMount = ({ injectBrightcoveVideoSchema, videoId }) => injectBrightcoveVideoSchema(videoId)

const View = () => null

// lifecycles :: React.Component -> React.Component
const lifecycles = componentDidMount(didMount)(View)

export default connect(
  null,
  mapDispatchToProps,
)(lifecycles)
